import StepController, { StepError } from "../../../lib/config_tool_step"
import { prepareStm32wb5x } from "../../../lib/chips/stm32wb5x"

// prepare_chip: bereitet den Chip mit dem Treiber seiner Familie vor (hardware.mcu, dmct.md #21). Der Treiber bekommt
// die Bridge, den Run (Platine, Station-URLs), die gepinnten Modul-Binaries und schreibt seine Entscheidungen ins
// Protokoll des Schritts. Texte kommen als ein Objekt aus der View, %{name} wird hier ersetzt.
const DRIVERS = { stm32wb5x: prepareStm32wb5x }

export default class extends StepController {
  static values = { mcu: String, modules: Object, texts: Object }

  async perform(run) {
    this.reset()
    const lines = []
    const log = (line) => {
      lines.push(line)
      this.output(lines.join("\n"))
    }
    try {
      const driver = DRIVERS[this.mcuValue]
      if (!driver) throw new StepError("unsupported_mcu", this.#say("unsupported_mcu", { mcu: this.mcuValue }))

      await driver({ bridge: this.bridge, run, modules: this.modulesValue, log, say: (key, vars) => this.#say(key, vars) })
    } catch (error) {
      lines.push(error.message)
      this.output(lines.join("\n"), true)
      throw error
    }
  }

  #say(key, vars = {}) {
    return Object.entries(vars).reduce((text, [name, value]) => text.replaceAll(`%{${name}}`, value), this.textsValue[key] ?? key)
  }
}
